// Step 1: trim -> "_Hello, World!"
// Step 2: toLowerCase -> "_hello, world!"
// Step 3: replace non-alphanumeric -> "_hello_world_"
// Step 4: trim underscores -> "hello_world"
export const normalizeKey = (input: string): string => {
  return input
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');
};

// Get a file name without extension
// Example: "file.txt" -> "file"
export const getFileNameWithoutExtension = (filename: string) =>
  filename.slice(0, filename.lastIndexOf('.')) || filename;
